import Controller from '@ember/controller';
import { service } from '@ember/service';
import type Link from 'ember-link/link';
import type LinkManagerService from 'ember-link/services/link-manager';
import type FeatureFlagsService from 'garaje/services/feature-flags';

interface Tab {
  label: string;
  link: Link;
}

export default class VisitorsInvitesController extends Controller {
  @service declare featureFlags: FeatureFlagsService;
  @service declare linkManager: LinkManagerService;

  get showGroupInviteTabs(): boolean {
    return this.featureFlags.isEnabled('visitors-generic-invite-link');
  }

  get tabs(): Tab[] {
    return [
      {
        label: 'Single Invites',
        link: this.linkManager.createUILink({
          route: 'visitors.invites.index',
        }),
      },
      {
        label: 'Group Invites',
        link: this.linkManager.createUILink({
          route: 'visitors.invites.groups.index',
        }),
      },
    ];
  }
}
